import React, { useEffect, useState } from 'react';
import { Instagram, ArrowUpRight } from 'lucide-react';
import Reveal from '../../components/Reveal';
import { getSocialConfig, getInstagramFeed } from '../../lib/social';
import { LIFESTYLE, FLAVOURS } from '../../data/mock';

const FALLBACK = [LIFESTYLE.cinemaMain, FLAVOURS.strawberry.scene, LIFESTYLE.cinemaRed, LIFESTYLE.cinemaFire];

function handleOf(url) {
  try { return '@' + new URL(url).pathname.split('/').filter(Boolean)[0]; } catch { return '@smangreece'; }
}

export default function InstagramSection() {
  const [url, setUrl] = useState('');
  const [items, setItems] = useState([]);

  useEffect(() => {
    getSocialConfig().then((c) => {
      setUrl(c.links?.instagram || '');
      if (c.feed_enabled) getInstagramFeed().then((f) => setItems(f.items || []));
    });
  }, []);

  if (!url) return null;
  const tiles = items.length ? items : FALLBACK.map((image, i) => ({ id: `f${i}`, image, permalink: url, caption: 'S-MAN' }));
  return (
    <section className="py-20 md:py-24 bg-[#050505]" data-testid="instagram-section">
      <div className="max-w-[1400px] mx-auto px-5">
        <Reveal className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
          <div>
            <p className="font-cond tracking-[0.3em] text-sm text-flavour flavour-transition">FOLLOW THE ENERGY</p>
            <h2 className="font-display text-4xl md:text-6xl mt-2">{handleOf(url)}</h2>
          </div>
          <a href={url} target="_blank" rel="noopener noreferrer" data-testid="instagram-follow-btn"
            className="inline-flex items-center gap-2 self-start md:self-auto px-6 py-3 rounded-full bg-flavour text-black font-cond tracking-widest text-sm hover:scale-[1.03] transition-transform">
            <Instagram className="w-4 h-4" /> FOLLOW ON INSTAGRAM <ArrowUpRight className="w-4 h-4" />
          </a>
        </Reveal>
        {tiles.length > 0 && (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-testid="instagram-feed-grid">
            {tiles.map((m) => (
              <a key={m.id} href={m.permalink} target="_blank" rel="noopener noreferrer"
                className="group relative aspect-square overflow-hidden rounded-xl border border-white/10">
                <img src={m.image} alt={m.caption || 'S-MAN Instagram'} loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors flex items-center justify-center">
                  <Instagram className="w-7 h-7 text-white opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>
              </a>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
